import { SchemaExplorerUIOptions } from '../interfaces/schemaExplorer';

export const SCHEMA_EXPLORER_DEFAULT_UI_OPTIONS: SchemaExplorerUIOptions = {
  searchAreaBorder: true,
  showFieldTypeIcon: false,
  allowTableCreation: true,
  showTableMenuOption: true,
  showRelationsLineage: true
};
